import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { server } from "./server";
import axios from "axios";
import { toast } from "react-toastify";
import Loading from "./Components/global/Loading";
import UnAuthorized from "./Components/global/UnAuthorized";
const AuthContext = createContext({});
export const Authentication = ({ children }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loadingInitial, setLoadingInitial] = useState(true);

  useEffect(() => {
    const verifyToken = localStorage.getItem("token");

    if (verifyToken) {
      const getMyProfile = async () => {
        try {
          const { data } = await axios.get(`${server}/auth/profile`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });

          setUser(data?.data);
          setToken(localStorage.getItem("token"));
          setLoadingInitial(false);
        } catch (e) {
          setLoadingInitial(false);
          return console.error(e?.response?.data?.message || e?.message);
        }
      };

      getMyProfile();
    } else {
      setLoadingInitial(false);
    }
  }, []);

  const loginWithEmailAndPassword = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${server}/auth/login`, null, {
        params: {
          email,
          password,
        },
      });

      setUser(data?.data);
      localStorage.setItem("token", data?.token);
      setToken(data?.token);
    } catch (e) {
      toast.error(e?.response?.data || e?.message);
    } finally {
      setLoading(false);
    }
  };

  const registerWithEmailAndPassword = async (
    name,
    mobile,
    email,
    password,
  ) => {
    setLoading(true);
    try {
      const formData = {
        name,
        mobile,
        email,
        password,
      };

      const { data } = await axios.post(`${server}/user/register`, formData);
      setUser(data?.data);
      localStorage.setItem("token", data?.token);
      setToken(data?.token);
    } catch (e) {
      toast.error(e?.response?.data || e?.message);
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setLoading(true);
    try {
      setUser(null);
      localStorage.clear();
      navigate("/login");
      setLoading(false);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const memoValues = useMemo(
    () => ({
      user,
      loading,
      registerWithEmailAndPassword,
      loginWithEmailAndPassword,
      logout,
      token,
    }),
    [user, loading, token],
  );

  if (loadingInitial) {
    return <Loading />;
  }

  return (
    <AuthContext.Provider value={memoValues}>
      {!loadingInitial && children}
    </AuthContext.Provider>
  );
};

export default function useAuth() {
  return useContext(AuthContext);
}
